import { DataConnectionError, provideDataClass } from "scrivito"

import { getPisaClient } from "../pisaClient"

export const User = provideDataClass(
  "User",
  (async () => {
    const apiClient = await getPisaClient("user")
    return {
      attributes: {}, // fetchAttributes("user"),
      connection: {
        index: async () => {
          throw new DataConnectionError(
            "Listing users is not supported due to data protection reasons."
          )
        },
        get: async (id: string) => {
          return apiClient?.get(id)
        }
      }
    }
  })()
)

// TODO: validate with yup?
// export async function postProcessUserData(
//   data: DataConnectionResultItem
// ): Promise<DataConnectionResultItem> {
//   // Use the data item cached by Scrivito instead of connecting to the backend directly
//   const pisaUserId = await load(() => CurrentUser.get("pisaUserId"))
//   if (data._id !== pisaUserId) return data

//   return {
//     ...data,

//     staff: false,
//     email: await load(() => CurrentUser.get("email")),
//     familyName: await load(() => CurrentUser.get("familyName")),
//     givenName: await load(() => CurrentUser.get("givenName")),
//     image: { url: await load(() => CurrentUser.get("picture")) },
//     name: await load(() => CurrentUser.get("name"))
//     // Ignoring `salutation`, since neoletter's attribute is a plain string (e.g. `Frau` or `Herr`), whereas PisaSales responds with an enum value such as `F` or `M`.
//   }
// }
